import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './components/paginator/paginator.component';
import {
  NgPagination,
  NgPaginationEllipsis,
  NgPaginationFirst, NgPaginationLast, NgPaginationNext, NgPaginationNumber, NgPaginationPrevious
} from './components/paginator/ng-pagination/ng-pagination.component';
import { FormsModule } from '@angular/forms';
import { SortIconComponent } from './components/sort-icon/sort-icon.component';
import { InlineSVGModule } from 'ng-inline-svg';
@NgModule({
  declarations: [PaginatorComponent, NgPagination, SortIconComponent, NgPagination,
    NgPaginationEllipsis, NgPaginationFirst, NgPaginationLast, NgPaginationPrevious, NgPaginationNumber, NgPaginationNext],
  imports: [CommonModule, FormsModule, InlineSVGModule  ],
  exports: [PaginatorComponent, NgPagination, SortIconComponent, NgPagination,
    NgPaginationEllipsis, NgPaginationFirst, NgPaginationLast,NgPaginationPrevious, NgPaginationNumber, NgPaginationNext],
})
export class CRUDTableModule { }
